export default __webpack_public_path__ + "static/media/undraw_podcast_q6p7.bc208ca6.svg";